import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { BiTrash } from "react-icons/bi";
import { addItemshoppingCartAction, deleteItemshoppingCartAction } from '../../redux/actions';
import Delivery from './Delivery';
import PaymentInputForm from './PaymentInputForm';
import Footer from '../LayOut/Footer';
import Header from '../LayOut/Header';
import {Loading, whatsAppText, numberFormat} from '../Extras'
import { Formik, Form, Field, ErrorMessage } from 'formik';


const textStyle = { 
	fontWeight: 'bold',
	fontSize: 18,
	color: '#2a2a2a',
	borderStyle: 'none',
	backgroundColor:'transparent',
	marginBottom: '15px',
}

const textStyle_ = { 
	fontWeight: 'bold',
	fontSize: 18,
	color: '#2a2a2a',
	borderStyle: 'none',
	backgroundColor:'transparent',
	marginBottom: '15px',
}

const productCardStyle = {
	borderStyle:'none',
	borderRadius: 5,
	boxShadow: '2px 3px 5px #E7E7E7',
	paddingTop: '15px',
	paddingBottom: '15px'
}


class ShoppingCart extends React.Component {
	state = {
		name: '',
		telephone: '',
		message: '',
		email: '',
		send: false,
		commentary: '',
		direction: '',
		deliveryRegion: '',
		deliveryCommune: '',
		deliveryPrice: 0,
		deliveryState: '',
		payment: '',
		loading: false,
		termsConditions: false,
		visibleShoppingCart: true,
	};

	changeState = async (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value
		});
	};

	changeDelivery = (type) => {

		if(type === 'delivery'){
			this.setState({
				deliveryState : true
			})
		}
		else if(type === 'withdraw'){
			this.setState({
				deliveryState : false
			})
		}
	}

	changeRegion = (deliveryRegion, deliveryPrice) => {
		this.setState({
			deliveryRegion,
			deliveryCommune: '',
			deliveryPrice
		});
	};

	changeCommune = (commune) => {
		this.setState({
			deliveryCommune: commune.label
		});
	};

	changeQuantity = (item, quantity, quantity_) => {
		if (quantity < 9 && quantity_ === 1) {
			quantity = quantity + quantity_;
		} else if (quantity > 1 && quantity_ === -1) {
			quantity = quantity + quantity_;
		}

		this.props.addItemShoppingCart(item, quantity, item.subCategory);
	};
	
	displayShoppingCart = () => (
		<Fragment>
			<div className="row mb-2 mt-3 ml-3 mr-3">
				{this.props.shoppingCart.map((item, index) => {
					return (
						<div 
							key={index}
							className="row justify-content-center" 
							style={productCardStyle}
						>	
							{this.displayImage(item)}
							{this.displayText(item)}
						</div>
					);
				})}
			</div>
				
		</Fragment>
			
	)

	displayImage = (item) => (
		<div className="col-4">
			<img
				src={item.images.length === 0 ? require('../../images/simple2.png') : item.images[0].url}
				alt="..."
				style={{ aspectRatio: 135 / 76, height: '80px', width: '100%', borderRadius: '10%' }}
			/>
		</div>
		
	);

	displayText = (item) => (
		<div className="col-8 align-items-flex-start">
				<div className="row align-items-center">
					<div className="col-7" style={{ fontWeight: 'bold', fontSize: 13, color: '#2a2a2a' }}>
						{item.name} {item.subCategory !== null ? item.subCategory : ''}
					</div>
					<div
						className="offset-2 col-2"
						style={{
							fontSize: 12,
							color: 'black'
						}}
					>
						<button
							style={{borderStyle:'none', backgroundColor:'transparent'}}
							onClick={() => this.props.deleteItemShoppingCart(item)}
						>
							<BiTrash size={22} color={this.props.shopColor} />
						</button>
						
					</div>
				</div>

				<div
					className="row justify-content-end pr-4"
					style={{
						color: this.props.shopColor,
						fontSize: 16,
						fontWeight: '600',
					}}
				>
					{`$ ${item.quantity} x ${numberFormat(item.price)}`}
				</div>
		</div>
	);
					
	
	
		

	displayOrderSummary = () => {
		const deliveryPrice = parseInt(this.props.deliveryPrice);
		const productPrice = parseInt(this.props.total || 0);
    let totalPrice = (productPrice).toString();
    
		if(this.props.deliveryState === true && this.props.toggleWhatsAppMethod === false){
			totalPrice = (deliveryPrice + productPrice).toString();
		}
		
		console.log("1,", this.props.deliveryState, this.props.toggleWhatsAppMethod)
		return (
			<Fragment>
				<div
					className="col-md-3 offset-md-4 px-3 pt-3"
					style={{backgroundColor:'#1d2126'}}
				>	
					{this.props.message === '' ? '' : 'Mensaje Enviado'}

					<div
						style={{...textStyle_, color:'white'}}
					>
						Revisa y Confirma
					</div>

					<div className="d-flex justify-content-end"
						style={{fontSize: 16, color: this.props.shopColor}}
					>
						Resumen
					</div>

					<div className="row my-1">
						<div className="col-6"
							style={{fontSize: 16, color: this.props.shopColor}}
						>
							Subtotal
						</div>
						<div className="col-6 d-flex justify-content-end"
							style={{fontSize: 16, color: this.props.shopColor}}
						>
							{`$ ${numberFormat(this.props.total)}`}
						</div>
					</div>

					{this.props.deliveryState === true && this.props.toggleWhatsAppMethod === false ? 
						<div className="row">
							<div className="col-6"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								Despacho
							</div>
							
							<div className="col-6 d-flex justify-content-end"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								{`$ ${numberFormat(this.props.deliveryPrice)}`}
							</div>
						</div> : ''}
					
						<div className="p-3 row mt-2"
							style={{backgroundColor:'#11191e'}}
						>
							<div className="col-6"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								Total
							</div>

							<div className="col-6 d-flex justify-content-end"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								{`$ ${numberFormat(totalPrice)}`}
								
							</div>
						</div>
			  </div>		
			</Fragment>
		)
	}

	displayNoItems = () => (
		<>
      <Header />
      {this.displayOrderSummary()}
      <div className="row align-items-center justify-content-center"
        style={{marginTop: 100, color: '#2a2a2a', fontSize:22}}
      >
        Tu carrito está vacío
      </div>
      <Footer/>
		</>
	)

	render() {

		if(this.state.loading){
			return(<Fragment> <Loading/> </Fragment>)
		}

		if (this.props.shoppingCart.length === 0) {
			return this.displayNoItems()
		}

		const url_ = whatsAppText(
			this.props.toggleWhatsAppMethod,
			this.props.shoppingCart, 
			this.props.shopName, 
			this.props.total, 
			this.props.whatsapp, 
			this.state.name, 
			this.state.direction,
			this.state.deliveryCommune,
			this.state.deliveryRegion,
			this.state.commentary,
			this.state.deliveryPrice,
			this.state.deliveryState,
			this.props.dispatchTime,
			this.props.shopDirection)

		return (
			<Fragment>
				<Header />
				<div 
					className="col-md-3 offset-md-4 mt-3"
				>	
					<button 
						style={{...textStyle, paddingLeft:0}}
						onClick={() => this.setState({...this.state, visibleShoppingCart: !this.state.visibleShoppingCart})}
					>
						Revisar Mi Compra
						{this.state.visibleShoppingCart ? <FiChevronUp className="ml-2 pb-1" size={25} color={this.props.shopColor} /> : <FiChevronDown className="ml-2 pb-1" size={25} color={this.props.shopColor} />}
					</button>		
					
					{this.state.visibleShoppingCart && this.displayShoppingCart()}
					
					<Delivery deliveryState={this.state.deliveryState} deliveryRegion={this.state.deliveryRegion} deliveryCommune={this.state.deliveryCommune} changeRegion={this.changeRegion} changeCommune={this.changeCommune} changeDelivery={this.changeDelivery}/>
					
					<PaymentInputForm 
						dispatchTime = {this.props.dispatchTime}
						shopDirection = {this.props.shopDirection} 
						deliveryState={this.state.deliveryState} 
						changeState={this.changeState}
						email={this.state.email}
						name={this.state.name}
						direction={this.state.direction}
						commentary={this.state.commentary}
						email={this.state.email}
						deliveryPrice={this.state.deliveryPrice}
						total={this.props.total}
						toggleWhatsAppMethod={this.props.toggleWhatsAppMethod}
						shopColor={this.props.shopColor}
						url_ = {url_}
						shopName = {this.props.shopName}
						shoppingCart = {this.props.shoppingCart}
						whatsapp = {this.props.whatsapp		}
          />		
				</div>
				<Footer />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	shoppingCart: state.shoppingCart,
	shopName: state.shopName,
	total: state.total,
	shopEmail: state.shopEmail,
	shopUid: state.shopUid,
	delivery: state.delivery,
	shopColor: state.shopColor,
	whatsapp: state.whatsapp,
	dispatchTime: state.dispatchTime,
	shopDirection: state.shopDirection,
	toggleWhatsAppMethod: state.toggleWhatsAppMethod,
	toggleMailMethod: state.toggleMailMethod,
	togglePaymentMethod: state.togglePaymentMethod,

});

const mapDispatchToProps = (dispatch) => ({
	addItemShoppingCart(product, quantity, subCategory) {
		dispatch(addItemshoppingCartAction(product, quantity, subCategory));
	},

	deleteItemShoppingCart(product) {
		dispatch(deleteItemshoppingCartAction(product));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);
